{
  "en": {
    "searchForm": {
      "location": {
        "title": "Location",
        "where": "Where",
        "search": "Search destinations",
        "nearby": "Nearby",
        "nearbySubtitle": "Find what's around you",
        "suggestedDestinations": "Suggested destinations",
        "collapsed": {
          "campgroundsNear": "Campgrounds near {name}",
          "campgroundsNearby": "Campgrounds nearby",
          "rvsInMapArea": "RVs in map area",
          "rvsNear": "RVs near {name}",
          "rvsNearby": "RVs nearby"
        }
      },
      "dates": {
        "title": "Dates",
        "when": "When",
        "add": "Add dates",
        "anyDates": "Any dates"
      },
      "guests": {
        "title": "Guests",
        "who": "Who",
        "add": "Add guests",
        "count": "0 guests | 1 guest | {n} guests",
        "petsSuffix": "• pets"
      },
      "rentalType": {
        "title": "Rental type",
        "allRVs": "All RVs",
        "drivable": "Drivable",
        "towable": "Towable",
        "delivery": "Delivery",
        "descriptions": {
          "allRVs": "Just looking for a rental?",
          "drivable": "Drive a motorhome yourself",
          "towable": "Tow a trailer with your vehicle",
          "delivery": "Get an RV delivered anywhere"
        }
      }
    }
  },
  "fr": {
    "searchForm": {
      "location": {
        "title": "Endroit",
        "where": "Où",
        "search": "Rechercher un endroit",
        "nearby": "À proximité",
        "nearbySubtitle": "Découvrez ce qu'il y a autour de vous",
        "suggestedDestinations": "Destinations suggérées",
        "collapsed": {
          "campgroundsNear": "{name} : Campings",
          "campgroundsNearby": "Campings à proximité",
          "rvsInMapArea": "VRs sur la carte",
          "rvsNear": "{name} : VRs",
          "rvsNearby": "VRs à proximité"
        }
      },
      "dates": {
        "title": "Dates",
        "when": "Quand",
        "add": "Dates",
        "anyDates": "Dates flexibles"
      },
      "guests": {
        "title": "Invités",
        "who": "Qui",
        "add": "Qui vient?",
        "count": "0 invité | 1 invité | {n} invités",
        "petsSuffix": "• animaux"
      },
      "rentalType": {
        "title": "Type de location",
        "allRVs": "Tous les VRs",
        "drivable": "Motorisés",
        "towable": "Roulottes",
        "delivery": "Livraison",
        "descriptions": {
          "allRVs": "Vous cherchez simplement une location?",
          "drivable": "Conduisez un motorisé vous-même",
          "towable": "Remorquez une roulotte avec votre véhicule",
          "delivery": "Faites livrer un VR n'importe où"
        }
      }
    }
  }
}
